import React from 'react'
import Main from '../components/HostelPage/Main'

const ListHostelPage = () => {
  return (
    <div>
      <Main/>
    </div>
  )
}

export default ListHostelPage